<app-toaster [config]="toastService.toaster"></app-toaster>
<div>
  <mat-toolbar class="toolbar-border">
    Slab Approval Requests
    <div class="pull-right" style="display: flex; align-items: center;">
      <label style="margin-right: 12px; font-weight: 500;">Status:</label>
      <label style="margin-right: 16px; cursor: pointer;">
        <input type="radio" name="status" value="all" [(ngModel)]="selectedStatus" (change)="onStatusChange()" style="margin-right: 4px;">
        All
      </label>
      <label style="margin-right: 16px; cursor: pointer;">
        <input type="radio" name="status" value="pending" [(ngModel)]="selectedStatus" (change)="onStatusChange()" style="margin-right: 4px;">
        Pending
      </label>
      <label style="margin-right: 16px; cursor: pointer;">
        <input type="radio" name="status" value="approved" [(ngModel)]="selectedStatus" (change)="onStatusChange()" style="margin-right: 4px;">
        Approved
      </label>
      <label style="cursor: pointer;">
        <input type="radio" name="status" value="rejected" [(ngModel)]="selectedStatus" (change)="onStatusChange()" style="margin-right: 4px;">
        Rejected
      </label>
    </div>
  </mat-toolbar>
  <data-table [table]="table" (paginationChange)="fetchTableData()" (headerToSort)="sortByHeader($event)"></data-table>
  <app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>
</div>
